export default __webpack_public_path__ + "static/media/happy.c71caa0c.svg";